import doc                    from 'decorators/doc';
import model                  from 'decorators/model';
import { Timestampable }      from 'helpers/traits';
import { Blamable }           from 'helpers/traits';
import InvoicePrivateApiModel from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.staticLabel('Classe divisionnaire', false)
@model.urnResource('divisional_class')
@doc.path('/divisional_classes/{?id}')
export default class DivisionalClassModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'code': id;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'code': string;
		'id': string;
		'label': string;
		'updatedAt': string;
	}> = {};

	@doc.string declare code: string;
	@doc.string declare label: string;
}